<template>
    <div class="support-plan-preview"
         v-bind:class="[fontFamilyClass, fontSizeClass]">

        <div class="print-header">
            <b-row>
                <b-col>
                    {{ exportHeader.left }}
                </b-col>
                <b-col class="text-right">
                    {{ exportHeader.right }}
                </b-col>
            </b-row>
        </div>

        <h1 v-if="doc.title != defaultDocTitle">
            {{doc.title}}
        </h1>

        <p class="intro-text"
           v-if="docData.introText">
            {{ docData.introText }}
        </p>
        <div v-for="s in docData.strategies">
            <h2>
                {{ s.categoryTitle }}
                &raquo;
                {{ s.subjectTitle }}
                &raquo;
                <br/>
                {{ s.strategy.title }}
            </h2>
            <p class="show-line-breaks">
                {{ s.strategy.text }}
            </p>
            <template v-if="s.notes">
                <div class="notes">
                    <p>NOTES:</p>
                    <p v-for="para in splitTextByLineBreaks(s.notes)">
                        {{para}}
                    </p>
                </div>
            </template>
            <div v-if="docData.showAnnotations">
                <p v-for="aid in s.strategy.annotations">
                    {{ getAnnotation(aid).text }}
                </p>
            </div>
            <p v-if="docData.showLinks">
                {{s.strategy.links}}
            </p>
        </div>

        <div class="print-footer">
            {{ exportFooter.left }}
            <!-- can't do page numbers here -->
        </div>

    </div>
</template>

<script>

    import Vue from 'vue'
    import ToolMixin from '@/providers/ToolMixin'
    import SupportPlanMixin from "../providers/SupportPlanMixin";

    export default Vue.extend({
        name: "SupportPlanPreview",
        mixins: [ToolMixin, SupportPlanMixin],
        computed: {
            // NB: we are stealing the font classes from ToolOutputPage, even though we are not using that
            // component here (don't want to have to do pagination in the same way)...
            fontFamilyClass() {
                return 'tool-output-page--font-family-' + this.docData.fontFace
            },
            fontSizeClass() {
                return 'tool-output-page--font-size-' + this.docData.fontSize
            },
            defaultDocTitle() {
                return this.$api.DEFAULT_DOC_TITLE
            }
        }

    })

</script>

<style lang="scss">
    .support-plan-preview {
        h1 {
            font-size: 2.5em;
        }
        h1 {
            font-size: 2rem;
        }

        .intro-text {
            white-space: pre-line;
        }

        .notes {
            font-style: italic;

            p {
                margin-bottom: .25rem;
            }
        }

        .print-header {
            margin-bottom: 1.5em;
        }

        .print-footer {
            margin-top: 1.5em;
            padding-top: 1em;
            border-top: solid 1px #ccc;
        }
    }
</style>